import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import CloseIcon from '../../../themes/svg/closeIcon';
import ErrorIcon from '../../../themes/svg/errorIcon';

const BuyWithAddToOrderButton = (props) => {
  const [showConfirmation, setShowConfirmation] = useState(false);
  const handleClick = () => {
    setShowConfirmation(true);
  };

  const addToOrder = () => {
    setShowConfirmation(false);
    props.performChangeOrder(props.calculateTaxModel, props.designId);
  };

  const closeWindowsWithInvalidConfigurationsModal = () => {
    props.controlWindowsWithInvalidConfigurationsModal(false, []);
  };

  return (
    <div>
      <button
        className="btn btn-primary"
        type="submit"
        onClick={handleClick}
        disabled={props.disabled}
      >
        <span className="desktop-only inline">{props.text}</span>
        <span className="tablet-mobile-only inline">{props.textMobile}</span>
      </button>
      <Modal
        isOpen={showConfirmation}
        className="estimatebuilder-modal"
        overlayClassName="estimatebuilder-modal-overlay"
        style={{
          content: {
            width: 450,
          },
        }}
      >
        <div className="confirmation-modal">
          <h2 className="modal-header desktop-tablet-only">Are you sure?</h2>
          <h2 className="modal-header mobile-only">Are you sure?</h2>
          <div className="modal-close" tabIndex="-1" role="button" onClick={() => { setShowConfirmation(false); }}>
            <CloseIcon />
          </div>
          <div className="modal-body">
            <div className="confirmation-message">Once products have been added, you will not be able to return to add additional blinds to windows.</div>
            <div className="confirmation-message">Continue for payment?</div>
            <button
              className="btn btn-primary"
              type="submit"
              onClick={addToOrder}
            >
              <span className="desktop-only inline">Continue</span>
              <span className="tablet-mobile-only inline">Continue</span>
            </button>
          </div>
        </div>
      </Modal>
      <Modal
        isOpen={props.showWindowsWithInvalidConfigurationsModal}
        className="estimatebuilder-modal"
        overlayClassName="estimatebuilder-modal-overlay"
        style={{
          content: {
            width: 450,
          },
        }}
      >
        <div className="confirmation-modal">
          <div className="confirmation-modal">
            <h2 className="modal-header desktop-tablet-only">Oops...</h2>
            <h2 className="modal-header mobile-only">Oops...</h2>
            <div className="modal-close" tabIndex="-1" role="button" onClick={() => { closeWindowsWithInvalidConfigurationsModal(); }}>
              <CloseIcon />
            </div>
            <div
              className="modal-body"
              style={{
              alignItems: 'center',
            }}
            >
              <ErrorIcon width="60px" height="60px" />
              <h1 style={{
                color: 'black',
                fontSize: '1.25rem',
              }}
              >Invalid Configuration
              </h1>
              <div className="confirmation-message"><p>Please check the following windows and try again:</p>
                <ul style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  fontWeight: '600',
                }}
                >
                  {props.windowsWithInvalidConfigurations.map(x => <li key={x}>{x}</li>)}
                </ul>

                <button
                  className="btn btn-primary"
                  type="submit"
                  onClick={() => { closeWindowsWithInvalidConfigurationsModal(); }}
                  style={{
                    width: '100%',
                  }}
                >
                  <span className="desktop-only inline">Return To Page</span>
                  <span className="tablet-mobile-only inline">Return To Page</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </div>);
};


BuyWithAddToOrderButton.propTypes = {
  disabled: PropTypes.bool,
  text: PropTypes.string.isRequired,
  textMobile: PropTypes.string.isRequired,
  designId: PropTypes.string.isRequired,
  calculateTaxModel: PropTypes.shape({
    customerEmail: PropTypes.string.isRequired,
    orderNumber: PropTypes.string.isRequired,
    siteId: PropTypes.number.isRequired,
    shippingAddress: PropTypes.shape({
      firstName: PropTypes.string.isRequired,
      lastName: PropTypes.string.isRequired,
      address1: PropTypes.string.isRequired,
      address2: PropTypes.string,
      city: PropTypes.string.isRequired,
      province: PropTypes.string.isRequired,
      postalCode: PropTypes.string.isRequired,
      phone: PropTypes.string.isRequired,
      country: PropTypes.string.isRequired,
    }),
    lineItems: PropTypes.arrayOf(PropTypes.shape({
      number: PropTypes.number.isRequired,
      amount: PropTypes.number.isRequired,
      quantity: PropTypes.number.isRequired,
      productId: PropTypes.number.isRequired,
      productName: PropTypes.string.isRequired,
      discounted: PropTypes.bool.isRequired,
      lineItemGroupGuid: PropTypes.string.isRequired,
    })).isRequired,
  }).isRequired,
  performChangeOrder: PropTypes.func.isRequired,
  controlWindowsWithInvalidConfigurationsModal: PropTypes.func.isRequired,
  showWindowsWithInvalidConfigurationsModal: PropTypes.bool.isRequired,
  windowsWithInvalidConfigurations: PropTypes.arrayOf(PropTypes.string).isRequired,
};

BuyWithAddToOrderButton.defaultProps = {
  disabled: false,
};


export default BuyWithAddToOrderButton;
